import PostList from '../components/post/List'
import PostCreate from '../components/post/Create'
import PostUpdate from '../components/post/Update'
import PostShow from '../components/post/Show'

export default [
  {
    name: 'PostList', path: '/posts/', component: PostList, meta: {
      requiresAuth: true
    }
  },
  {
    name: 'PostCreate', path: '/posts/create', component: PostCreate, meta: {
      requiresAuth: true
    }
  },
  {
    name: 'PostUpdate', path: '/posts/edit/:id', component: PostUpdate, meta: {
      requiresAuth: true
    }
  },
  {
    name: 'PostShow', path: '/posts/show/:id', component: PostShow, meta: {
      requiresAuth: true
    }
  }
]
